import React from "react";
import { NavLink } from "react-router-dom";
import {
  LayoutDashboard, Building2, FileText, Settings, PiggyBank,
  ShieldCheck, BarChart3, SlidersHorizontal, LifeBuoy, UserPlus, KanbanSquare, Activity, Smartphone, ArrowRightLeft, Radar,
  FlaskConical, Eye, Handshake
} from "lucide-react";
import { OrbitMark } from "../OrbitMark";
import { useSidebar } from "./SidebarContext";
import { useDemoModeAvailable } from "../../hooks/useDemoModeAvailable";

export function Sidebar() {
  const { isMobile, close } = useSidebar();
  // Demo mode exists on dev only. On production the probe 404s and the link
  // never renders, so nobody is offered a switch they must not touch.
  const demoModeAvailable = useDemoModeAvailable();
  // On mobile the sidebar is a drawer — tapping a link should dismiss it.
  const onNav = () => { if (isMobile) close(); };

  return (
    <aside className="sidebar">
      <div className="brand">
        <span className="brand-mark"><OrbitMark size={18} /></span>
        <span className="brand-word">
          Orbit SA
          <small>Platform Admin</small>
        </span>
      </div>

      <div className="nav-group">
        <h5>Overview</h5>
        <nav>
          <NavLink to="/" end onClick={onNav}>
            <LayoutDashboard size={16} /> Dashboard
          </NavLink>
          <NavLink to="/finance" onClick={onNav}>
            <PiggyBank size={16} /> Finance
          </NavLink>
          <NavLink to="/analytics" onClick={onNav}>
            <BarChart3 size={16} /> Analytics
          </NavLink>
        </nav>
      </div>

      <div className="nav-group">
        <h5>Customers</h5>
        <nav>
          <NavLink to="/companies" onClick={onNav}>
            <Building2 size={16} /> Companies
          </NavLink>
          <NavLink to="/reseller-clients" onClick={onNav}>
            <Handshake size={16} /> Reseller clients
          </NavLink>
        </nav>
      </div>

      <div className="nav-group">
        <h5>Growth</h5>
        <nav>
          <NavLink to="/referrals" onClick={onNav}>
            <UserPlus size={16} /> Referrals
          </NavLink>
        </nav>
      </div>

      <div className="nav-group">
        <h5>Operations</h5>
        <nav>
          <NavLink to="/support" onClick={onNav}>
            <LifeBuoy size={16} /> Support
          </NavLink>
          <NavLink to="/migrations" onClick={onNav}>
            <ArrowRightLeft size={16} /> Migrations
          </NavLink>
          <NavLink to="/mission-control" onClick={onNav}>
            <Radar size={16} /> Mission Control
          </NavLink>
          <NavLink to="/board" onClick={onNav}>
            <KanbanSquare size={16} /> Board
          </NavLink>
          <NavLink to="/logs" onClick={onNav}>
            <FileText size={16} /> Logs
          </NavLink>
          <NavLink to="/client-access" onClick={onNav}>
            <Eye size={16} /> Client access
          </NavLink>
          <NavLink to="/remote-config" onClick={onNav}>
            <SlidersHorizontal size={16} /> Remote config
          </NavLink>
          <NavLink to="/app-releases" onClick={onNav}>
            <Smartphone size={16} /> App Releases
          </NavLink>
          <NavLink to="/system-health" onClick={onNav}>
            <Activity size={16} /> System health
          </NavLink>
          {demoModeAvailable ? (
            <NavLink to="/demo-mode" onClick={onNav}>
              <FlaskConical size={16} /> Demo mode
            </NavLink>
          ) : null}
          <NavLink to="/settings" onClick={onNav}>
            <Settings size={16} /> Settings
          </NavLink>
        </nav>
      </div>

      <div className="sidebar-footer">
        <div className="row" style={{ gap: 8, marginBottom: 6 }}>
          <ShieldCheck size={14} style={{ color: "var(--success)" }} />
          <span>Restricted • SSO + MFA</span>
        </div>
        <div className="faint">v0.1.0 • internal use only</div>
      </div>
    </aside>
  );
}
